import axios from 'axios';

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Response interceptor for token refresh
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes('/auth/')) {
      originalRequest._retry = true;
      try {
        await API.post('/auth/refresh');
        return API(originalRequest);
      } catch {
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  logout: () => API.post('/auth/logout'),
  me: () => API.get('/auth/me'),
  refresh: () => API.post('/auth/refresh'),
};

export const contractsAPI = {
  upload: (formData) => API.post('/contracts/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
  }),
  analyzeText: (data) => API.post('/contracts/analyze-text', data, { timeout: 120000 }),
  list: () => API.get('/contracts'),
  get: (id) => API.get(`/contracts/${id}`),
};

export const reportsAPI = {
  get: (id) => API.get(`/reports/${id}`),
};

export const usageAPI = {
  get: () => API.get('/usage'),
};

export const billingAPI = {
  createCheckout: (data) => API.post('/billing/create-checkout-session', data),
  checkoutStatus: (sessionId) => API.get(`/billing/checkout-status/${sessionId}`),
  createPortalSession: (data) => API.post('/billing/create-portal-session', data),
};

export const comparisonAPI = {
  compare: (formData) => API.post('/contracts/compare', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 180000,
  }),
  get: (id) => API.get(`/comparisons/${id}`),
  list: () => API.get('/comparisons'),
};

export const demoAPI = {
  getAnalysis: () => API.get('/demo/analysis'),
};

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (!detail) return error?.message || 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(' ');
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default API;
